<template>
    <div class="slider-container">
      <transition name="fade" mode="out-in">
        <img
          :key="currentIndex"
          :src="imagenes[currentIndex]"
          class="slider-image"
        />
      </transition>
  
      <!-- Indicadores -->
      <div class="indicadores">
        <span
          v-for="(img, index) in imagenes"
          :key="index"
          :class="{ activo: index === currentIndex }"
        ></span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PromocionesFullScreen",
  
    data() {
      return {
        currentIndex: 0,
  
        imagenes: [
          "/images/1ae2b18d-e540-4ea7-96a4-c2c66c48110c.jpg",
      "/images/704c52f5-385d-4711-b2a0-15328b99c825.jpg",
      "/images/2896a9c1-8247-4e1d-b67f-1561aeaf1dfb.jpg",
      "/images/b0a7f165-2425-4770-b6a1-91627ebb4c69.jpg",
      "/images/e78d9bd2-eae5-43b3-854d-936f8b1f4c7f.jpg",
      "/images/03673649-1352-4204-a9f4-94b4bdf4b26a.jpg",
      "/images/605b0529-8590-4ea6-85b3-9acc8155b934.jpg"
        ],
  
        intervalo: null
      };
    },
  
    mounted() {
      this.iniciarSlider();
    },
  
    beforeDestroy() {
      clearInterval(this.intervalo);
    },
  
    methods: {
      iniciarSlider() {
        this.intervalo = setInterval(() => {
          this.currentIndex++;
  
          if (this.currentIndex >= this.imagenes.length) {
            this.currentIndex = 0;
          }
        }, 5000); // cambia cada 5 segundos
      }
    }
  };
  </script>
  
  <style scoped>
  .slider-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
}

.slider-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
  
  /* Animación */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  /* Indicadores */
  .indicadores {
    position: absolute;
    bottom: 25px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  
  .indicadores span {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: rgba(255,255,255,0.5);
    transition: 0.3s;
  }
  
  .indicadores .activo {
    background: white;
    transform: scale(1.2);
  }
  </style>